"use strict";

/* -------------------------------------------------------------------------

	PUNITED.employee

	トップページのスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */
// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.employee) PUNITED.employee = {};

(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.employee;
  /* -----------------------------------------------------
  
  ----------------------------------------------------- */
})();

$(function () {
  PUNITED.utils.headLine({
    width: 1542.33,
    height: 78.204,
    d: [{
      command: 'M',
      points: [[-13941.548, -11609.783]]
    }, {
      command: 'c',
      points: [[-110.166, -65.755], [-450.458, -100.451], [-595.464, -56.042]]
    }, {
      command: 's',
      points: [[-188.881, 51.448], [-350.641, 56.042], [-595.531, -75.317], [-595.531, -75.317]]
    }],
    translate: [15483.365, 11686.785]
  }, {
    width: 577.637,
    height: 30.516,
    d: [{
      command: 'M',
      points: [[-14906.241, -11657.321]]
    }, {
      command: 'c',
      points: [[-41.229, -24.606], [-168.579, -37.593], [-222.847, -20.973]]
    }, {
      command: 's',
      points: [[-70.687, 19.255], [-131.225, 20.973], [-222.871, -28.187], [-222.871, -28.187]]
    }],
    translate: [15483.365, 11686.764]
  });
});